const CXO_CONTEXT_FUNC_TO_CALL = 'Call-GenerateWebNAURL-Function';
const CXO_FACETS_FUNC_TO_CALL = 'RMC-Function';
const CXO_DATE_FORMAT = 'YYYY-MM-DD';
const MISSING_ARGUMENTS_TO_SAVE_CUSTOMER_PROPOSAL =
  'Missing arguments to make call for ressource saveCustomerProposals';

export {
  CXO_CONTEXT_FUNC_TO_CALL,
  CXO_FACETS_FUNC_TO_CALL,
  CXO_DATE_FORMAT,
  MISSING_ARGUMENTS_TO_SAVE_CUSTOMER_PROPOSAL,
};
